import { render, staticRenderFns } from "./Cameras.vue?vue&type=template&id=5641588f&scoped=true&"
import script from "./Cameras.vue?vue&type=script&lang=ts&"
export * from "./Cameras.vue?vue&type=script&lang=ts&"
import style0 from "./Cameras.vue?vue&type=style&index=0&id=5641588f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641588f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
